import { useLocation } from "react-router-dom";

import Colors from "@constants/Colors";
import UnreadNotification from "@icons/UnreadNotification";
import { Button } from "@mui/material";

import {
  StyledAvatar,
  StyledBox,
  StyledIcon,
  StyledRootBox,
  StyledTextBox,
  StyledTypography,
} from "./styles";

interface NavigationItemProps {
  title: string;
  options: {
    menuLabel: string;
    icon: string;
  }[];
  handleClick: (pathname: string) => void;
  newNotificationCount?: number | undefined;
}

const NavigationMenu = ({
  title,
  options,
  handleClick,
  newNotificationCount = 0,
}: NavigationItemProps) => {
  const currentPage = useLocation().pathname.split("/")[1];

  const navItems = options?.map((item) => {
    const itemPath =
      item.menuLabel === "Notifications"
        ? "notification-center"
        : item.menuLabel.toLowerCase().replace(/ /g, "-");
    const selected =
      currentPage === itemPath || (currentPage === "" && itemPath === "home");
    const unreadNotification =
      item.menuLabel === "Notifications" ? newNotificationCount > 0 : false;

    return (
      <StyledRootBox
        onClick={() => handleClick(itemPath)}
        key={item.menuLabel}
        selected={selected}
        header="false"
      >
        <Button disableTouchRipple>
          <StyledTextBox>
            {unreadNotification ? (
              <UnreadNotification
                strokeColor={selected ? Colors.primary : Colors.neutralblack}
              />
            ) : (
              <StyledIcon
                selected={selected}
                src={item.icon}
                alt={item.menuLabel}
              />
            )}
            {item.menuLabel}
          </StyledTextBox>
        </Button>
        {unreadNotification && (
          <StyledAvatar>
            {newNotificationCount > 50 ? `${50}+` : newNotificationCount}
          </StyledAvatar>
        )}
      </StyledRootBox>
    );
  });

  return (
    <>
      <StyledBox selected={false} header="true">
        <StyledTypography notification="false" selected>
          {title}
        </StyledTypography>
      </StyledBox>
      {navItems}
    </>
  );
};

NavigationMenu.defaultProps = {
  newNotificationCount: 0,
};

export default NavigationMenu;
